import React from 'react';
import './Logo.css';

const Logo = ({ onClick, className = '' }) => {
  return (
    <div className={`logo ${className}`} onClick={onClick}>
      <svg 
        className="logo-svg" 
        width="40" 
        height="40" 
        viewBox="0 0 40 40" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer circle representing peace and calm */}
        <circle cx="20" cy="20" r="18" stroke="#4A90E2" strokeWidth="2" fill="none"/>
        
        {/* Inner peace symbol - simplified dove */}
        <path 
          d="M20 8C18 8 16 9 15 11C14 13 15 15 16 17C17 19 19 20 20 20C21 20 23 19 24 17C25 15 26 13 25 11C24 9 22 8 20 8Z" 
          fill="#4A90E2"
        />
        
        {/* Calming waves */}
        <path 
          d="M8 25C10 23 12 22 15 22C18 22 20 23 22 25C24 27 26 29 28 31" 
          stroke="#48BB78" 
          strokeWidth="2" 
          strokeLinecap="round"
        />
        
        {/* Mindfulness dot */}
        <circle cx="20" cy="28" r="2" fill="#ED8936"/>
        
        {/* Serenity lines */}
        <path 
          d="M12 18L16 18" 
          stroke="#667EEA" 
          strokeWidth="1.5" 
          strokeLinecap="round"
        />
        <path 
          d="M24 18L28 18" 
          stroke="#667EEA" 
          strokeWidth="1.5" 
          strokeLinecap="round"
        />
      </svg>
      <span className="logo-text">Peaceful Mind</span>
    </div>
  );
};

export default Logo; 